<template>
  <div class="all">
    <img src="../../assets/bgc.png" class="img" />
    <div class="main">
      <div class="cicle"></div>
      <div style="font-size: 16px; color: #fff; margin-left: 10px">首页</div>
    </div>
    <div class="logo-item">
      <div class="logo"></div>
      <div class="information">simpletalk.fun</div>
    </div>
    <div class="IM">
      <div style="font-size: 32px; font-weight: 600">simple talk talk</div>
      <div style="font-size: 32px; font-weight: 600">简单聊聊，不止于此</div>
      <div style="font-size: 20px; color: #8392aa">
        沉浸式的社交体验，保障社交信息安全
      </div>
    </div>
    <img src="../../assets/register.png" class="register" />
    <img src="../../assets/IM.png" class="IMB" />
    <div class="safety">
      <div style="font-size: 32px; font-weight: 600">安全简易的即时通讯</div>
      <div style="font-size: 16px">SECURITY</div>
      <div style="display: flex">
        <div class="cicleall" style="background-color: #c92773"></div>
        <div class="cicleall ml10" style="background-color: #dc31b2"></div>
        <div class="cicleall ml10" style="background-color: #cb3ad8"></div>
      </div>
      <div style="font-size: 16px" class="mt10">云端加密，保障个人通讯隐私</div>
    </div>
    <img src="../../assets/encryption.png" class="encryption" />
    <div class="share">
      <div style="font-size: 32px; font-weight: 600">朋友圈分享动态</div>
      <div style="font-size: 16px">SHARE HAPPINESS</div>
      <div style="display: flex">
        <div class="cicleall" style="background-color: #c92773"></div>
        <div class="cicleall ml10" style="background-color: #dc31b2"></div>
        <div class="cicleall ml10" style="background-color: #cb3ad8"></div>
      </div>
      <div style="font-size: 16px" class="mt10">文字，照片，短视频，生活趣事随时分享</div>
    </div>
    <div class="bottom">
      <div style="font-size: 20px; color: #000">
        Copyright 2022 simpletalk.fun All Rights Reserved.
      </div>
      <div class="logo1"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style  scoped>
.ml10 {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.img {
  position: relative;
}
.border {
  border: 1p solid red;
}
.main {
  display: flex;
  width: 150px;
  height: 40px;
  position: fixed;
  top: 37%;
  left: 3%;
  background-color: #d152c7;
  border-radius: 30px;
  align-items: center;
  z-index:9999;
}
.cicle {
  margin-left: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #999;
}
.cicleall {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.logo-item {
  position: absolute;
  top: 10%;
  left: 20%;
  display: flex;
  align-items: center;
}
.logo {
  width: 80px;
  height: 80px;
  background-image: url("../../assets/logo.png");
  background-size: cover;
}
.logo1 {
  width: 50px;
  height: 50px;
  background-image: url("../../assets/logo.png");
  background-size: cover;
}
.information {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin-left: 10px;
}
.IM {
  position: absolute;
  top: 35%;
  left: 20%;
  /* display: flex;
  flex-direction: column; */
  color: #fff;
}
.register {
  position: absolute;
  top: 10%;
  right: 18%;
  border-radius: 30px;
}
.IMB {
  position: absolute;
  top: 150%;
  left: 5%;
  border-radius: 30px;
}
.safety {
  position: absolute;
  top: 130%;
  right: 22%;
  color: #fff;
}
.encryption {
  position: absolute;
  top: 280%;
  left: 15%;
  border-radius: 30px;
}
.share {
  position: absolute;
  top: 280%;
  right: 21%;
  color: #fff;
}
.bottom {
  display: flex;
  height: 80px;
  justify-content: space-around;
  align-items: center;
}
</style>